
import { mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters({
      cartTime: 'cart/cartTime'
    })
  }
}
